import RichTooltip from './variations/rich-tooltip/rich-tooltip';
import SimpleTooltip from './variations/simple-tooltip/simple-tooltip';

const Tooltip = { Simple: SimpleTooltip, Rich: RichTooltip };

export default Tooltip;
